import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { TransitionPortal } from "gatsby-plugin-transition-link"
import {
  ThemeProvider,
  TaskBar,
  GlobalStyle as ThemeGlobalStyle,
  List,
  ProgressBar,
  Tree,
  // TreeProps
} from "@react95/core"
import { Awfext326050 } from "@react95/icons/esm/react/awfext326050"
import { Qfecheck111 } from "@react95/icons/esm/react/Qfecheck111"
import { CurvesAndColors100 } from "@react95/icons/esm/react/CurvesAndColors100"
import { Defrag } from "@react95/icons/esm/react/Defrag"
import { Defrag4 } from "@react95/icons/esm/react/Defrag4"
import { Joy102 } from "@react95/icons/esm/react/Joy102"
import { Ccapi106 } from "@react95/icons/esm/react/ccapi106"
import { Url102 } from "@react95/icons/esm/react/url102"

import Loading from "components/Loading"
import TaskList from "components/TaskList"

import * as S from "./styled"
import StyleBase from "../../styles/global"
import ReactMarkdown from 'react-markdown'

const { icons } = Tree;


const treeNodes = {
  data: [
    {
      id: 0,
      label: <ReactMarkdown>Hackathon Prize from The Graph: $800</ReactMarkdown>,
      icon: <Joy102 variant="16x16_4" />,
    },
    {
      id: 1,
      label: <ReactMarkdown>The Income from IndieHackers Accelerator R1: $350</ReactMarkdown>,
      icon: <Defrag variant="16x16_4" />,
    },
    {
      id: 2,
      label: <ReactMarkdown>Scroll Airdrop: $1950</ReactMarkdown>,
      icon: <CurvesAndColors100 variant="16x16_4" />,
    },
    {
      id: 3,
      label: <ReactMarkdown>BeThink Hackathon in Shanghai: $3197</ReactMarkdown>,
      icon: <Defrag4 variant="16x16_4" />,
    },
    {
      id: 4,
      label: <ReactMarkdown>From [@seek_web3](https://x.com/seek_web3): $110</ReactMarkdown>,
      icon: <Ccapi106 variant="16x16_4" />,
    },
    // TODO: change the icons.
    {
      id: 4,
      label: <ReactMarkdown>From SpringX: $2500</ReactMarkdown>,
      // icon: <Ccapi106 variant="16x16_4" />,
    },
    {
      id: 4,
      label: <ReactMarkdown>From PicWe: $1000</ReactMarkdown>,
      // icon: <Ccapi106 variant="16x16_4" />,
    },
    {
      id: 4,
      label: <ReactMarkdown>From DeagentAI: $695</ReactMarkdown>,
      // icon: <Ccapi106 variant="16x16_4" />,
    },
    // {
    //   id: 2,
    //   label: 'Grant 0x02',
    //   // children: [
    //   //   {
    //   //     id: 3,
    //   //     label: 'Indie',
    //   //     children: [
    //   //       {
    //   //         id: 4,
    //   //         label: 'Weezer',
    //   //         icon: <icons.FILE_MEDIA variant="16x16_4" />,
    //   //         onClick: () => alert('nice!'),
    //   //       },
    //   //       {
    //   //         id: 5,
    //   //         label: 'Supergrass',
    //   //         icon: <icons.FILE_MEDIA variant="16x16_4" />,
    //   //       },
    //   //     ],
    //   //   },
    //   // ],
    // },
    // {
    //   id: 3,
    //   label: 'Others...',
    //   // children: [
    //   //   {
    //   //     id: 0,
    //   //     label: 'Fira Code.ttf',
    //   //     icon: <icons.FILE_FONT variant="16x16_4" />,
    //   //   },
    //   //   {
    //   //     id: 1,
    //   //     label: 'Journal.txt',
    //   //     icon: <icons.FILE_TEXT variant="16x16_4" />,
    //   //   },
    //   // ],
    // },
    // {
    //   id: 4,
    //   label: 'config.cfg',
    //   icon: <icons.FILE_SETTINGS variant="16x16_4" />,
    // },
    // {
    //   id: 5,
    //   label: 'random_file',
    //   icon: <icons.FILE_UNKNOWN variant="16x16_4" />,
    // },
  ],
};

const Sidebar = React.lazy(() => import("components/Sidebar"))
const MenuBar = React.lazy(() => import("components/MenuBar"))

const Layout = ({ children }) => {
  const [showModal, setShowModal] = useState(true)
  const [readingMode, setReadingMode] = useState(false)
  const [hasMounted, setHasMounted] = useState(false)

  const closeModal = () => {
    setShowModal(false)
  }

  useEffect(() => {
    setHasMounted(true)
  }, [])

  if (!hasMounted) {
    return null
  }

  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  )

  return (
    <ThemeProvider>
      <ThemeGlobalStyle />
      <StyleBase />
      <S.LayoutWrapper>
        {/* {!isMobile && (
          <TransitionPortal level="top">
            <React.Suspense fallback={<Loading left="7.5%" />}>
              <Sidebar />
            </React.Suspense>
          </TransitionPortal>
        )} */}

        {showModal && (
          <S.LayoutMain
            isMobile={isMobile}
            closeModal={closeModal}
            icon={
              <Awfext326050 variant="16x16_4" alt="Windows Explorer icon" />
            }
            title={isMobile ? "TaiShang AI SaaS System" : "TaiShang AI SaaS System"}
            menu={[
            ]}
          >
            <br></br>
            <h1 style={{ textAlign: 'center', fontSize: '2em' }}><CurvesAndColors100 variant="32x32_4" />&nbsp;TaiShang AI SaaS System</h1>
            {/* <a href="https://x.com/intent/follow?screen_name=0xleeduckgo" target="_blank"> 👉 View my twitter.</a> */}
            <br></br>
            <p style={{ textAlign: 'center' }}>-- <b>Next-Gen Labor Market</b> Based on AI Agents & Multiple Chains.</p>
            <br></br>
            <p style={{ textAlign: 'center' }}> 0x03 Targets 🎯 --</p>
            <p style={{ textAlign: 'center' }}> <b> 
            * 🤖 Enable AI agents to earn money as workers.
              <br></br>
            * 👔 Allow users to assign tasks as Bosses.
              <br></br>
            * 💰 Allow users could invest AI Agents Like VCs.</b></p>
            <hr style={{ 
              border: 'none', 
              height: '2px', 
              background: 'linear-gradient(90deg, #c0c0c0 0%, #808080 50%, #c0c0c0 100%)',
              borderTop: '1px solid #808080',
              borderBottom: '1px solid #ffffff',
              margin: '10px 0'
            }} />
            <p style={{ textAlign: 'center' }}>
              <b>Pitch Deck:&nbsp;</b>
              <a href="https://pitch.com/v/0610_flipflop_solana_ai-saas-q8za9f" target="_blank" rel="noopener noreferrer">
                <img 
                  src="/assets/img/powerpoint.png" 
                  alt="deck" 
                  width="32" 
                  height="32" 
                  style={{ 
                    display: 'inline', 
                    verticalAlign: 'middle', 
                    marginRight: '8px',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer'
                  }}
                  onMouseEnter={(e) => {
                    (e.target as HTMLImageElement).style.width = '48px';
                    (e.target as HTMLImageElement).style.height = '48px';
                  }}
                  onMouseLeave={(e) => {
                    (e.target as HTMLImageElement).style.width = '32px';
                    (e.target as HTMLImageElement).style.height = '32px';
                  }}
                />
              </a> | &nbsp;
              <b>Twitter:&nbsp;</b>
              <a href="https://x.com/root_mud" target="_blank" rel="noopener noreferrer">
              <img 
                  src="/assets/img/msn.png" 
                  alt="twitter" 
                  width="32" 
                  height="32" 
                  style={{ 
                    display: 'inline', 
                    verticalAlign: 'middle', 
                    marginRight: '8px',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer'
                  }}
                  onMouseEnter={(e) => {
                    (e.target as HTMLImageElement).style.width = '48px';
                    (e.target as HTMLImageElement).style.height = '48px';
                  }}
                  onMouseLeave={(e) => {
                    (e.target as HTMLImageElement).style.width = '32px';
                    (e.target as HTMLImageElement).style.height = '32px';
                  }}
                />
              </a> | &nbsp;
              <b>Demo Video:&nbsp;</b>
              <a href="​https://youtu.be/xLo_p4d6Hn8?si=cU3eCgdFeFp3-8Bl" target="_blank" rel="noopener noreferrer">
              <img 
                  src="/assets/img/video.ico" 
                  alt="youtube" 
                  width="32" 
                  height="32" 
                  style={{ 
                    display: 'inline', 
                    verticalAlign: 'middle', 
                    marginRight: '8px',
                    transition: 'all 0.3s ease',
                    cursor: 'pointer'
                  }}
                  onMouseEnter={(e) => {
                    (e.target as HTMLImageElement).style.width = '48px';
                    (e.target as HTMLImageElement).style.height = '48px';
                  }}
                  onMouseLeave={(e) => {
                    (e.target as HTMLImageElement).style.width = '32px';
                    (e.target as HTMLImageElement).style.height = '32px';
                  }}
                />
              </a> 
            </p>
            <hr style={{ 
              border: 'none', 
              height: '2px', 
              background: 'linear-gradient(90deg, #c0c0c0 0%, #808080 50%, #c0c0c0 100%)',
              borderTop: '1px solid #808080',
              borderBottom: '1px solid #ffffff',
              margin: '10px 0'
            }} />
            <p style={{ textAlign: 'center' }}>* Solana Portal: &nbsp;<a href="https://ai-saas-portal-solana-n134.vercel.app/" target="_blank" rel="noopener noreferrer">👉&nbsp;jump to&nbsp;👈</a></p>
            <p style={{ textAlign: 'center' }}>* Movement Portal: &nbsp;<a href="https://ai-saas.rootmud.xyz/" target="_blank" rel="noopener noreferrer">👉&nbsp;jump to&nbsp;👈</a></p>
            <p style={{ textAlign: 'center' }}>* EVM Portal: &nbsp;<a href="https://google.com" target="_blank" rel="noopener noreferrer">TODO</a></p>
            <p style={{ textAlign: 'center' }}>* Web2 Portal: &nbsp;<a href="https://google.com" target="_blank" rel="noopener noreferrer">TODO</a></p>
            <br></br>
            <p style={{ textAlign: 'center' }}>* Source Codes: &nbsp;<a href="https://github.com/NonceGeek/tai-shang-micro-ai-saas" target="_blank" rel="noopener noreferrer">👉&nbsp;jump to&nbsp;👈</a></p>
            <hr style={{ 
              border: 'none', 
              height: '2px', 
              background: 'linear-gradient(90deg, #c0c0c0 0%, #808080 50%, #c0c0c0 100%)',
              borderTop: '1px solid #808080',
              borderBottom: '1px solid #ffffff',
              margin: '10px 0'
            }} />
            <p style={{ textAlign: 'center' }}>We are going to buidl --</p>
            <p style={{ textAlign: 'center' }}>
              * 🤖 An AI Agent Framework that adapted to multiple chains & multiple models.
              <br></br>
              * 👔 A Micro SaaS platform where users can hire AI agents.
              <br></br>
              * 💰 A launchpad where users can invest in the AI agents they find useful & cool.</p>
              <br></br>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px' }}>
              <span>Building Process:</span>
              <ProgressBar width={800} percent={12.8} />
            </div>
          </S.LayoutMain>
        )}

        {!isMobile && (
          <TransitionPortal level="top">
            <React.Suspense fallback={<Loading right="2.5%" />}>
              <MenuBar
                setReadingMode={setReadingMode}
                readingMode={readingMode}
              />
            </React.Suspense>
          </TransitionPortal>
        )}
      </S.LayoutWrapper>
      <TransitionPortal level="top">
        <TaskBar
          list={
            <TaskList
              setReadingMode={setReadingMode}
              readingMode={readingMode}
              setShowModal={setShowModal}
            />
          }
        />
      </TransitionPortal>
    </ThemeProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
